<template>
    <ModalWrapper
        v-model="modal"
        :subtitle="info?.carRentCompanyName"
        :max-width="800"
        scrollable
        :loading="infoLoading"
    >
        <template v-slot:title>
            {{ info.modelName }}
        </template>
        <v-tabs v-model="tab" hide-slider>
            <v-tab class="text-uppercase">
                {{ $t('description') }}
            </v-tab>
            <v-tab class="text-uppercase">
                {{ `${$t('carsRent.pick-up_point')}` }}
            </v-tab>
        </v-tabs>
        <v-window v-model="tab">
            <v-window-item>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-carousel height="170px" hide-delimiters :show-arrows="images.length > 1 ? 'hover' : false">
                            <v-carousel-item v-for="(image, imageIndex) in images" :key="imageIndex">
                                <v-img :src="$filters.imageUrl(image.url, 300)" height="170px" cover />
                            </v-carousel-item>
                        </v-carousel>
                    </v-col>
                    <v-col cols="12" md="8">
                        <div v-if="info?.shortDescription" class="mb-3">
                            <div class="text-h6">{{ $t('description_type.short') }}</div>
                            <div v-html="info.shortDescription" />
                        </div>
                        <div v-if="info?.description" class="mb-3">
                            <div class="text-h6">{{ $t('description_type.general') }}</div>
                            <div v-html="info.description" />
                        </div>
                        <template v-if="info?.features?.length">
                            <div class="text-h6">{{ `${$t('included')}:` }}</div>
                            <ul>
                                <template v-for="feature in info.features" :key="feature">
                                    <li v-text="$t(`carsRent.${feature.toLowerCase()}`)" />
                                </template>
                            </ul>
                        </template>
                    </v-col>
                </v-row>
            </v-window-item>
            <v-window-item>
                <cars-map
                    v-model="mapExpanded"
                    :offers="pickUpPoints"
                    :parent="true"
                    style="max-height: 500px; position: unset"
                />
            </v-window-item>
        </v-window>
    </ModalWrapper>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_CARS_INFO_MODAL} from '@/utils/event-bus'
    import CarsMap from '@/components/carsRent/search/CarsMap.vue'

    @Component({
        components: {CarsMap},
    })
    export class CarInfoModal extends Vue {
        info = {
            modelName: '',
        }
        offer = {
            pickUpPoints: {},
        }
        modal = false
        infoLoading = true
        mapExpanded = false
        carInfo = {}
        tab = null

        mounted() {
            EventBus.$on(SHOW_CARS_INFO_MODAL, this.showModal)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_CARS_INFO_MODAL, this.showModal)
        }

        async showModal(product) {
            this.modal = true
            this.offer = product.offer
            try {
                this.info = await this.$api.carRentInfo.get({offerKey: this.offer.offerKey})
            } catch (e) {
                this.info = product.info
                return
            }
            this.infoLoading = false
        }

        get pickUpPoints() {
            return this.offer.pickUpPoints.map(point => {
                const newPoint = {...point}
                newPoint.offerKey = this.offer.offerKey
                return newPoint
            })
        }

        get images() {
            if (!this.info.images) return []
            return this.info.images
        }
    }

    export default CarInfoModal
</script>
